module.exports = {
	"naslov": "Okupacija Jugoslavije",
	"slika": "fotke/italijanska-vojska-na-balkanu.jpg",
	"opis": "Fašistički okupatori su pregazili tvoju zemlju. Regularna vojska je poražena za svega par dana. Čuo si da komunisti i neki oficiri nameravaju da nastave otpor.",
	"pitanje": "Šta ćeš učiniti?",
	"izbori": [
		{
			"opis": "Pridružiću se komunistima!",
			"link": "1941-05-15-pripreme"
		},
		{
			"opis": "Pridružiću se oficirima!",
			"link": "1941-05-15-ravna-gora"
		},
		{
			"opis": "Ostaću kod kuće.",
			"link": "1941-05-10-odvodjenje"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/05-01/podaci.json
// module id = 38
// module chunks = 0